import React, { useEffect } from 'react';
import { getUserProfile } from '../api/profile';

const Unsubscribe = () => {
    useEffect(() => {
        document.title = "Unsubscribe | Jazz Esl"
        const unsubscribe = async () => {
            try {
                let profileData = JSON.parse(sessionStorage.getItem("profileData"));
                if (!profileData) {
                    profileData = await getUserProfile();
                    // console.log(profileData)
                }
                // console.log(profileData)
                const msisdn = profileData?.phone;
                if (!msisdn) {
                    return;
                }

                sessionStorage.clear();

                const response = await fetch('https://unsubscribe.jazzesl.com.pk/api/encrypt', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ 
                        mobile: msisdn, 
                        domainName: 'jazz_esl' 
                    }),
                });

                const data = await response.json();
                if (data.status === 'success' && data.data.mobile && data.data.domainName) {
                    window.location.replace(`https://unsubscribe.jazzesl.com.pk/${data.data.mobile}/${data.data.domainName}`);
                }
            } catch (error) {
            }
        };

        unsubscribe();
    }, []);

    return <div></div>;
};

export default Unsubscribe; 